import { FC, ReactNode } from 'react'
import { DominoConfigAvatar, DominoConfigAvatarType } from './Avatar'

const DominoConfig: FC & DominoConfigAvatarType = (): ReactNode => <></>

DominoConfig.Avatar = DominoConfigAvatar

export default DominoConfig
